import { MESSAGE_CHANNEL } from "../../constants";

export const isMessageChannelRequest = (status: MESSAGE_CHANNEL): boolean =>
  status === MESSAGE_CHANNEL.REQUEST;

export const isMessageChannelSSE = (status: MESSAGE_CHANNEL): boolean =>
  status === MESSAGE_CHANNEL.SSE;
